module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAxNyI+CiAgPGRlZnMvPgogIDxwYXRoIGZpbGw9IiM0MjQyNDIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEwLjYuOGguMWwxMiA2LjggMS42LjktMS42LjktMTIgNi43YTEgMSAwIDAxLTEtMS43bDguNy00LjlIMS41YTEgMSAwIDAxLS4xLTJoMTcuMUw5LjcgMi42YTEgMSAwIDAxLS41LTEuMnYtLjFhMSAxIDAgMDExLjMtLjV6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/navi/images/next.svg
// module id = 0cad507afe9af9ee185c
// module chunks = 7